import React from 'react';
import GDPRLista from './GDPRLista';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../PartnerTooltips';

const cardStyle = {
  padding: 20
};

const GDPRBase = (props) => {
  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          GDPR
          <CustomTooltip text={getTooltip('gdpr')} id="gdprTT" />
        </div>
        <div className="row" style={cardStyle}>
          <div className="col-md-12">
            <GDPRLista
              {...props}
              globals={props.globals}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GDPRBase;
